import { useOverlays } from "contexts/OverlayContext";
import { DisableChartOfAccountsModal } from "./DisableChartOfAccountsModal";

export const DisableChartOfAccountsModalWrapper = () => {
    const { getOverlayInfo, closeOverlay, overlayIsClosing } = useOverlays();
    const overlayInfo = getOverlayInfo<"disableChartOfAccounts">(
        "disableChartOfAccounts",
    );

    if (!overlayInfo?.data) {
        return null;
    }

    return (
        <DisableChartOfAccountsModal
            show={!overlayIsClosing}
            onHide={closeOverlay}
            accounts={overlayInfo.data.accounts}
        />
    );
};
